<template>
  <div class="ArticlesTitle">
    <div class="ArticlesTitle_content">
      <div class="ArticlesTitle_content_tit">
        <div class="ArticlesTitle_back" @click="back">
          <i class="iconfont icon-jiantou3"></i>
        </div>
        <p class="ArticlesTitle_content_tit_p" v-show="articlesData" :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']">{{ articlesData.title }}</p>
      </div>
      <div class="ArticlesTitle_content_img" v-show="articlesData">
        <img :src="`${GLOBAL.imageUrl}${articlesData.icon}`" alt />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
    mixins: [mapMixin],
  props: ["articlesData"],
  methods: {
    back() {
      this.$router.back();
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
  .ArticlesTitle {
    width: 100%;
    height: 300px;
    min-height: 300px;
    background: rgba(38, 189, 226, 1);
    margin-top: 70px;
    .ArticlesTitle_content {
      width: 1200px;
      height: 100%;
      margin: auto;
      display: flex;
      flex-direction: row;
      .ArticlesTitle_content_tit {
        position: relative;
        // flex: 1;
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .ArticlesTitle_back {
          cursor: pointer;
          position: absolute;
          top: 0;
          left: 0;
          width: 40px;
          height: 40px;
          background: rgba(0, 0, 0, 0.3);
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            color: #fff;
            font-size: 20px;
          }
        }
        .ArticlesTitle_content_tit_p {
          font-size: 28px;
          color: #fff;
        }
        .ArticlesTitle_content_tit_con {
          margin-top: 20px;
          font-size: 16px;
          color: #fff;
        }
      }
      .ArticlesTitle_content_img {
        //  flex: 1;
        height: 100%;
        width: 50%;
        img {
          width: 100%;
          object-fit: cover;
          height: 100%;

          //  width: 50%;
        }
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .ArticlesTitle {
    width: 100%;
    height: 300px;
    min-height: 300px;
    background: rgba(38, 189, 226, 1);
    margin-top: 70px;
    .ArticlesTitle_content {
      width: 1200px;
      height: 100%;
      margin: auto;
      display: flex;
      flex-direction: row;
      .ArticlesTitle_content_tit {
        position: relative;
        // flex: 1;
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .ArticlesTitle_back {
          cursor: pointer;
          position: absolute;
          top: 0;
          left: 0;
          width: 40px;
          height: 40px;
          background: rgba(0, 0, 0, 0.3);
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            color: #fff;
            font-size: 20px;
          }
        }
        .ArticlesTitle_content_tit_p {
          font-size: 28px;
          color: #fff;
        }
        .ArticlesTitle_content_tit_con {
          margin-top: 20px;
          font-size: 16px;
          color: #fff;
        }
      }
      .ArticlesTitle_content_img {
        //  flex: 1;
        height: 100%;
        width: 50%;
        img {
          width: 100%;
          object-fit: cover;
          height: 100%;

          //  width: 50%;
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .ArticlesTitle {
    width: 100%;
    height: 300px;
    min-height: 300px;
    background: rgba(38, 189, 226, 1);
    margin-top: 70px;
    .ArticlesTitle_content {
      width: 100%;
      height: 100%;
      margin: auto;
      display: flex;
      flex-direction: row;
      position: relative;
      .ArticlesTitle_content_tit {
        position: absolute;
        // flex: 1;
        // width: 100%;
        padding: 10px;
        border-radius: 4px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .ArticlesTitle_back {
          cursor: pointer;
          position: absolute;
          top: 0;
          left: 0;
          width: 40px;
          height: 40px;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            color: #fff;
            font-size: 20px;
          }
        }
        .ArticlesTitle_content_tit_p {
          padding: 10px;
          display: flex;
          background: rgba(0,0,0,.5);
          font-size: 24px;
          font-weight: 600;
          color: #fff;
        }
        .ArticlesTitle_content_tit_con {
          margin-top: 20px;
          font-size: 16px;
          color: #fff;
        }
      }
      .ArticlesTitle_content_img {
        //  flex: 1;
        height: 100%;
        width: 100%;
        img {
          width: 100%;
          object-fit: cover;
          height: 100%;

          //  width: 50%;
        }
      }
    }
  }
}
</style>